
















































































import VueOptions from '@utils/VueOptions'

settings = 
  name: 'AdvanceShow'
  resources:
    advance:
      resourceName: "advance"
      slug: "offers/:offerId/advance"
    paperwork_requirements:
      resourceName: "paperwork_requirement"
      slug: "offers/:offerId/paperwork_requirements"
  vue:
    props: ['offerId']

        
export default VueOptions.vue settings
